require('./brokerPensionPlanBeneficiariesView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const actions = require('actions/brokerPensionPlanBeneficiaries');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getFormattedString, formatAmount } = require('utilities/currencyHelper');
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');

class BrokerPensionPlanBeneficiariesView extends React.Component {
    constructor(props) {
        super(props);

        this.buildBreadcrumb = this.buildBreadcrumb.bind(this);
        this.buildBeneficiariesRows = this.buildBeneficiariesRows.bind(this);
        this.buildBeneficiariesTable = this.buildBeneficiariesTable.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.buildSideColumn = this.buildSideColumn.bind(this);
    }

    componentDidMount() {
        const { match: { params: { product, contractNumber } }, loadBeneficiaries, history } = this.props;

        loadBeneficiaries(product, contractNumber, history)
    }

    getAccountBalance(accountNumber) {
        const balance = this.props.immAccounts
            .get('byId')
            .find(immAccount => immAccount.getIn(['ibanComplex', 'codbban']) === accountNumber)
            .get('balance');

        return getFormattedString(balance);
    }

    buildBeneficiariesRows() {
        return this.props.immBrokerPensionPlanBeneficiaries.get('beneficiaries').map((beneficiary, index) => (
            <OKTableRow key={beneficiary + index}>
                <OKTableCell>
                    <div className="broker-pension-plan-beneficiaries-view__row-name">
                        {beneficiary}
                    </div>
                </OKTableCell>
                <OKTableCell>
                    <FormattedText value="pensionPlanBeneficiaries-beneficiary" />
                </OKTableCell>
            </OKTableRow>
        ));
    }

    buildBeneficiariesTable() {
        const titular = this.props.immBrokerPensionPlanBeneficiaries.get('titular');
        return (
            <OKTable>
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="pensionPlanBeneficiaries-name" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="pensionPlanBeneficiaries-interventionType" format="uppercase" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    <OKTableRow>
                        <OKTableCell>
                            <div className="broker-pension-plan-beneficiaries-view__row-name">
                                {titular}
                            </div>
                        </OKTableCell>
                        <OKTableCell>
                            <FormattedText value="pensionPlanBeneficiaries-titular" />
                        </OKTableCell>
                    </OKTableRow>
                    {this.buildBeneficiariesRows()}
                </tbody>
            </OKTable>
        );
    }

    buildBreadcrumb() {
        const { immMyInvestments, match: { params: { product, contractNumber } } } = this.props;

        const immPlan = immMyInvestments
            .getIn(['products', 'plans', 'stocks'])
            .find(immPlan => immPlan.get('product') === product && immPlan.get('contractNumber') === contractNumber)

        const planName = immPlan.get('name');

        const isin = immPlan.get('secID');
        const planUrl = getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', { isin: isin });

        return [
            {
                text: formatText('pensionPlanBeneficiaries-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: planName,
                url: planUrl
            },
            {
                text: formatText('pensionPlanBeneficiaries-beneficiaries'),
                url: ''
            }
        ];
    }

    buildContent() {
        const { immBrokerPensionPlanBeneficiaries } = this.props;
        let beneficiariesContent;

        if (immBrokerPensionPlanBeneficiaries.get('fetching')) {
            beneficiariesContent = <LoadingSection />;
        } else {
            beneficiariesContent = this.buildBeneficiariesTable();
        }

        return (
            <OKSectionBox title={formatText('pensionPlanBeneficiaries-assignedBeneficiaries')}>
                {beneficiariesContent}
            </OKSectionBox>
        );
    }

    buildSideColumn() {
        const { immMyInvestments, match: { params: { product, contractNumber } }, immBrokerPensionPlanBeneficiaries } = this.props;

        const immPlan = immMyInvestments
            .getIn(['products', 'plans', 'stocks'])
            .find(immPlan => immPlan.get('product') === product && immPlan.get('contractNumber') === contractNumber);

        const planName = immPlan.get('name');
        const code = immPlan.get('isin');
        const inWallet = formatAmount(immPlan.get('shares'), undefined, 3);
        const amountObject = {
            amount: immPlan.getIn(['totalValueEur', 'amount']),
            decimalsLength: 3,
            currency: immPlan.getIn(['totalValueEur', 'currency'])
        };
        const totalValue = getFormattedString(amountObject);
        const contractNumberString = immPlan.get('contractForTooltip');
        const accountNumber = immBrokerPensionPlanBeneficiaries.get('associatedAccount');
        const accountBalance = immBrokerPensionPlanBeneficiaries.get('fetched') ? this.getAccountBalance(accountNumber) : '';
        const titular = immBrokerPensionPlanBeneficiaries.get('titular');

        return (
            <ContentBox>
                <h4 className="broker-pension-plan-beneficiaries-view__sidecolumn-title">
                    <FormattedText value="pensionPlanBeneficiaries-pensionsPlan" />
                </h4>
                <section className="broker-pension-plan-beneficiaries-view__sidecolumn">
                    <h3 className="broker-pension-plan-beneficiaries-view__sidecolumn-plan-name">{planName}</h3>
                    <div className="broker-pension-plan-beneficiaries-view__sidecolumn-code">
                        <FormattedText value="pensionPlanBeneficiaries-dgsCode" injectedStrings={[code]} format="uppercase" />
                    </div>
                    <div className="broker-pension-plan-beneficiaries-view__sidecolumn-code">
                        <FormattedText value="pensionPlanBeneficiaries-contractNumber" injectedStrings={[contractNumberString]} format="uppercase" />
                    </div>
                    <div className="broker-pension-plan-beneficiaries-view__sidecolumn-inwallet">
                        <FormattedText value="pensionPlanBeneficiaries-sideColumnInWallet" /><br />
                        <FormattedText value="pensionPlanBeneficiaries-participants" injectedStrings={[inWallet, totalValue]} />
                    </div>
                    <div className="broker-pension-plan-beneficiaries-view__sidecolumn-block">
                        <FormattedText
                            value="pensionPlanBeneficiaries-firstTitular"
                            format="uppercase"
                            className="broker-pension-plan-beneficiaries-view__light-text"
                        />
                        <p className="broker-pension-plan-beneficiaries-view__bold-text">{titular}</p>
                        <FormattedText
                            value="pensionPlanBeneficiaries-interventionTypeTitular"
                            className="broker-pension-plan-beneficiaries-view__light-text"
                        />
                    </div>
                    <div className="broker-pension-plan-beneficiaries-view__sidecolumn-block">
                        <FormattedText
                            value="pensionPlanBeneficiaries-associatedAccount"
                            format="uppercase"
                            className="broker-pension-plan-beneficiaries-view__light-text"
                        />
                        <p className="broker-pension-plan-beneficiaries-view__bold-text">{accountNumber}</p>
                        <FormattedText
                            value="pensionPlanBeneficiaries-balance"
                            className="broker-pension-plan-beneficiaries-view__light-text"
                            injectedStrings={[accountBalance]}
                        />
                    </div>
                </section>
            </ContentBox>
        );
    }

    render() {
        return (
            <section className="broker-pension-plan-beneficiaries-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.buildBreadcrumb()}
                        finalTitle={getFinalTitle('pensionPlanBeneficiaries-title')}
                    />
                </OKCover>
                <section className="broker-pension-plan-beneficiaries-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            {this.buildContent()}
                        </div>
                        <div className="col-xs-4">
                            {this.buildSideColumn()}
                        </div>
                    </div>
                </section>
            </section>
        );
    }
}

BrokerPensionPlanBeneficiariesView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerPensionPlanBeneficiaries: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    loadBeneficiaries: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerPensionPlanBeneficiariesView;
module.exports.BrokerPensionPlanBeneficiariesView = connect(
    (state) => ({
        immAccounts: state.accounts,
        immBrokerPensionPlanBeneficiaries: state.brokerPensionPlanBeneficiaries,
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        loadBeneficiaries: actions.loadBeneficiaries
    }
)(withRouter(BrokerPensionPlanBeneficiariesView));
